import { render, staticRenderFns } from "./CategoryTemplateShortDescription.vue?vue&type=template&id=8bd3208e&"
import script from "./CategoryTemplateShortDescription.vue?vue&type=script&lang=js&"
export * from "./CategoryTemplateShortDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports